export const CHANGE_CHP_SEVERAL_VALUES = 'CHANGE_CHP_SEVERAL_VALUES';
export const RESET_CHP_STORE = 'RESET_CHP_STORE';

export const changeCHPSeveralValues = value => ({
  type: CHANGE_CHP_SEVERAL_VALUES,
  payload: value,
});

export const resetStore = () => ({
  type: RESET_CHP_STORE,
});
